import { AttachFileOutlined, CloseRounded } from "@mui/icons-material";
import { Box, Button, Divider } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { isEmpty, isNil, size } from "lodash";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { columnTypesDate } from "../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import AgGridTableWrapper from "../agGrid/AgGridTableWrapper";
import FileUploadField from "../inputs/FileUploadField";
import InputWrapper from "../inputs/shared/InputWrapper";
import Flx from "../layout/Flx";
import SelectFileAssignmentInput from "../inputs/SelectFileAssignmentInput";
import { grey } from "@mui/material/colors";
import FileUploadProcess from "./FileUploadProcess";

/**
 const BorrowerFilesContent = ({ borrower, setFormMeta, onSuccessFn }) => {
  const { loading, uploadBorrowerProfileDocuments } = useBorrowerPortalHook();

  const dispatch = useDispatch();
  const handleOnSubmit = (f, { onSuccessFn } = {}) => {
    uploadBorrowerProfileDocuments({
      _id: borrower?._id,
      files: f,
      onSuccessFn,
    });
  };
  return (
    <>
      <Flx column g={1.5}>
        <UploadFilesProcess
          loading={loading}
          onSubmit={handleOnSubmit}
          onCompleteFn={onSuccessFn}
        />
        <BasicFilesTable
          routeType={"useBorrowerPortalHook"}
          files={borrower?.borrowerDocuments}
          showStatus
          onEditClick={(d) =>
            setFormMeta({ type: BORROWER_SIDEBAR_FORM_TYPES.UPDATE_DOCUMENT_METADATA, data: d })
          }
          borrowerId={borrower?._id}
          compactTable
          hideIfEmpty
        />
     
      </Flx>
    </>
  );
};
 */
const UploadFilesProcess = ({
  loading,
  docType,
  docGroup,
  onSubmit,
  onCompleteFn,
  keyName,
}) => {
  // const handleOnSubmit = (f, { onSuccessFn } = {}) => {
  //   uploadBorrowerProfileDocuments({
  //     _id: loanId,
  //     files: f,
  //     onSuccessFn: (d) => {
  //       // dispatch(loanFetchedDataUwRequirementsSet(d));
  //       getLoanById({
  //         loanId,
  //         onSuccessFn: (data) => {
  //           // dispatch(loanDrilldownSet(data));
  //           onSuccessFn?.();
  //         },

  //         // onFailFn: () => dispatch(loanDrilldownSet({})),
  //       });
  //     },
  //   });
  // };

  return (
    <Flx column g={0.5}>
      {/* <Txt>Relevant Documents</Txt> */}
      <FileUploadProcess
        docType={docType}
        borderSize={2}
        disableCategoryAndTypeSelection
        disableCategoryAndTypeSelectionCount
        docGroup={docGroup}
        categoryAndTypeLabel={`Document Category`}
        keyName={keyName}
        onSubmit={onSubmit}
        onCompleteFn={onCompleteFn}
        loading={loading}
        showDivider
      />
    </Flx>
  );
};
export default UploadFilesProcess;
